import { useState } from 'react';
import { AdvancedOptions } from './AdvancedOptions';
import { ResourceSettings, SmallScreenDivider } from './ResourceSettings';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/20/solid';

import { usePacketInput } from '../Contexts/PacketInputContext';
import { SelectedSkills } from './SelectedSkills';
import { Mixpanel } from '../../../services/Mixpanel';
import CustomerIOPlaceholder from '../../../components/CustomerIOPlaceholder';

const LOCAL_STORAGE_KEY = 'isAdvancedOptionsOpen';
export const InputContainer = ({ children }) => {
  const [isAdvancedOptionsOpen, _setIsAdvancedOptionsOpen] = useState(
    localStorage.getItem(LOCAL_STORAGE_KEY) || false
  );
  const setIsAdvancedOptionsOpen = (value) => {
    if (value) {
      localStorage.setItem(LOCAL_STORAGE_KEY, true);
    } else {
      localStorage.removeItem(LOCAL_STORAGE_KEY);
    }
    _setIsAdvancedOptionsOpen(value);
  };
  const { inputType } = usePacketInput();

  return (
    <div className={`flex flex-col px-4 pb-2 border rounded-xl w-full bg-white border-gray-400`}>
      <div>{children}</div>
      {inputType.id !== 'topic' && <div className='sm:border-t border-gray-100 my-1 sm:my-2' />}
      <SelectedSkills />
      <div className='flex flex-col sm:flex-row  justify-between'>
        <ResourceSettings />
        {inputType.id === 'topic' && <SmallScreenDivider />}
        <div className='flex flex-row items-center'>
          <CustomerIOPlaceholder id='customerio-more-options' className='hidden sm:block' />
          <AdvancedOptionsButton
            isOpen={isAdvancedOptionsOpen}
            setIsOpen={setIsAdvancedOptionsOpen}
          />
        </div>
      </div>
      <AdvancedOptions isOpen={isAdvancedOptionsOpen} setIsOpen={setIsAdvancedOptionsOpen} />
    </div>
  );
};

const AdvancedOptionsButton = ({ isOpen, setIsOpen }) => {
  const ChevronIcon = isOpen ? (
    <ChevronUpIcon className='h-5 w-5 text-gray-400' />
  ) : (
    <ChevronDownIcon className='h-5 w-5 text-gray-400' />
  );
  return (
    <button
      onClick={() => {
        Mixpanel.track('More Options Clicked', { to: !isOpen });
        setIsOpen(!isOpen);
      }}
      className='text-gray-700 hover:text-gray-900 w-full sm:w-auto text-left text-sm flex flex-row items-center gap-x-1 px-2 py-3 sm:py-2 rounded-lg hover:bg-gray-100'>
      <div className='sm:hidden'>{ChevronIcon}</div>
      {isOpen ? 'Fewer Options' : 'More Options'}
      <div className='hidden sm:block'>{ChevronIcon}</div>
    </button>
  );
};
